








































import { GetInstanceResponse, TimeScope } from '@/classes/TayehApi/Instance';
import {Component, Inject, Prop, Vue} from 'vue-property-decorator'
import { format } from 'date-fns-jalali';
import { Instance } from '@/classes/TayehApi';
	@Component({
		components: {
			apexchart: () => import('vue-apexcharts')
		}
	})
	export default class ShopReportCustomerGrowth extends Vue {
		@Inject() getInstance: () => GetInstanceResponse;
		@Prop({default: 'رشد مشتریان'})
		title: string;

		@Prop({default: () => [TimeScope.MONTH, 30, 0]})
		this_period: [TimeScope, number, number];

		period: [TimeScope, number, number] = [TimeScope.MONTH, 30, 0];
		latest_users: any[] = [];
		series: [number]= [0];
		visitors_count = 0;
		sale_percent = 0;
		get chartOptions (){
			return {
			chart: {
				type: 'radialBar',
				offsetY: -20,
				sparkline: {
					enabled: true
				}
			},
			stroke: {
				lineCap: 'round',
				width: 1,
			},
			plotOptions: {
				radialBar: {
					startAngle: -90,
					endAngle: 90,
					hollow: {
						margin: {
							bottom: 32
						},
						// size: '100%',
						image: 'https://static.ty-sb1.tayeh.ir/tayeh-panel/assets/images/Socials_heart.svg',
						imageWidth: 28,
						imageHeight: 28,
						imageClipped: false,
						imageOffsetY: -30,
					},
					track: {
						background: "#eee",
						strokeWidth: '90%',
						strokeCap: 'round',
						margin: 14, // margin is in pixels
					},
					dataLabels: {
						name: {
							show: false
						},
						value: {
							fontSize: '22px',
							// fontFamily: 'IRANSans-fa',
							offsetY: 10,
							formatter: (): number => {
								return this.series[0];
							}
						}
					}
				}
			},
			grid: {
				padding: {
					top: -10
				}
			},
			labels: ['Average Results'],
		}
		}

		get Month(): string{
			let date: Date = new Date();
			// date.setMonth(date.getMonth() - this.period[2])
			return format(date, 'MMMMyy');
		}

		set Month(val: string) {
			this.period[2] += Number(val)	
		}

		nextMonth() {
			this.Month = '-1';
		}

		async getCustomerGrowth (period?: [TimeScope, number, number]) {
			const res = await Instance.getInstanceStatsCustomerGrowth(this.getInstance().id);
			this.latest_users = res.data.latest_customers;
			this.series = [res.data.customers_count];
			this.sale_percent = res.data.sale_percent;
			this.visitors_count = res.data.visitors_count;
		}

		created() {
			this.getCustomerGrowth()
		}
	}
